import React from 'react';
import { TRANSLATIONS } from '../../constants';
import { Language } from '../../enums';
import { useTranslate } from '../../hooks/common';
import { SupportEntryCategory } from '../../models';
import Jumbotron from '../common/Jumbotron';
import SupportEntryAccordion from './SupportEntryAccordion';

export interface SupportEntriesProps {
    supportEntryCategories: SupportEntryCategory[];
}

const SupportEntries = ({ supportEntryCategories }: SupportEntriesProps) => {
    const categoryAccordions = supportEntryCategories.map(x => <SupportEntryAccordion key={x.id} supportEntry={x} />);
    const translate = useTranslate();

    return categoryAccordions.length
        ? <><div className='section-title'>{translate(TRANSLATIONS.main.supportEntries)}</div>
            <div className='support-categories'>
                <Jumbotron>{categoryAccordions}</Jumbotron>
            </div></>
        : <></>;
};

export default SupportEntries;
